import React, { createContext, useState, useContext } from 'react';

const ProductContext = createContext();

export function ProductProvider({ children }) {
    const [productos, setProductos] = useState([]);
    const [productosQueryKey, setProductosQueryKey] = useState(null);
    const [cart, setCart] = useState([]);
    const [loading, setLoading] = useState(false);
    
    // Nuevas variables para almacenar información de navegación por categorías
    const [departmentName, setDepartmentName] = useState('');
    const [categoryName, setCategoryName] = useState('');
    const [subcategoryName, setSubcategoryName] = useState('');
    
    const [departmentId, setDepartmentId] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [subcategoryId, setSubcategoryId] = useState('');
    // Variable para almacenar el texto de búsqueda del usuario
    const [searchText, setSearchText] = useState('');

    return (
        <ProductContext.Provider value={{ 
            productos, 
            setProductos, 
            cart, 
            setCart, 
            loading, 
            setLoading,
            // Exportando las nuevas variables y sus setters
            departmentName,
            setDepartmentName,
            categoryName,
            setCategoryName,
            subcategoryName,
            setSubcategoryName,
            searchText,
            setSearchText,
            departmentId,
            setDepartmentId,
            categoryId,
            setCategoryId,
            subcategoryId,
            setSubcategoryId,
            productosQueryKey,
            setProductosQueryKey
        }} >
          {children}
        </ProductContext.Provider>
    );
}

export function useProducts() {
    const context = useContext(ProductContext);
    if (!context) {
        throw new Error('useProduct must be used within a ProductProvider');
    }
    return context;
}
